import {OperationTypeCount} from '@dms/api/settings';

import {aggregateOperationTypes} from './aggregateOperationTypes';

export interface PayPerUseOperationColumn {
  // Group id (shared label key, or raw pair key for ungrouped pairs).
  key: string;
  // Representative pair from the group, used to resolve the column label.
  resource: string;
  action: string;
}

/**
 * The leaderboard's operation-type columns — one per aggregated group, ordered
 * by summed count desc so cards and columns share the same ordering.
 */
export const getOperationTypeColumns = (
  operationTypes: OperationTypeCount[]
): PayPerUseOperationColumn[] =>
  aggregateOperationTypes(operationTypes).map((group) => ({
    key: group.groupId,
    resource: group.resource,
    action: group.action,
  }));
